import { API_URL } from "../api";
import { getAuthToken } from "../auth";

export async function documentRequest(
  path,
  { token, method = "GET", data, signal } = {},
) {
  const multipart = data instanceof FormData;
  const response = await fetch(`${API_URL}/documents/${path}`, {
    method,
    signal,
    headers: {
      Authorization: `Bearer ${token || getAuthToken()}`,
      ...(!multipart && data !== undefined
        ? { "Content-Type": "application/json" }
        : {}),
    },
    body:
      data === undefined ? undefined : multipart ? data : JSON.stringify(data),
  });
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    const message =
      body?.message ||
      body?.detail ||
      (body &&
        Object.entries(body)
          .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : v}`)
          .join("; ")) ||
      `Ошибка ${response.status}`;
    const error = new Error(message);
    error.body = body;
    error.status = response.status;
    throw error;
  }
  return body;
}

export async function downloadDocumentFile(id, kind, token) {
  const response = await fetch(`${API_URL}/documents/${id}/file/${kind}/`, {
    headers: { Authorization: `Bearer ${token || getAuthToken()}` },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.detail || body?.message || "Не удалось скачать файл");
  }
  const url = URL.createObjectURL(await response.blob());
  const a = document.createElement("a");
  a.href = url;
  a.download = `document_${id}.${kind === "xml" ? "xml" : "docx"}`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
